import { onlyNumbers } from "./formValidation";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

export const stringCompare = (a: string, b: string, keepTheSameRow?: boolean) => {
  if(keepTheSameRow) return 0
  if (!a || !b) return 0;
  const newA = String(a).toLowerCase();
  const newB = String(b).toLowerCase();
  return newA.localeCompare(newB);
}

export const transformToNumberAndCompare = (a: string, b: string, keepTheSameRow?: boolean) => {
  if(keepTheSameRow) return 0
  return parseInt(onlyNumbers(a || '0')) - parseInt(onlyNumbers(b || '0'))
}

export const compareNegativeCurrency = (a: string, b: string, keepTheSameRow?: boolean) => {
  if(keepTheSameRow) return 0
  const aModified = a.toString().replace('$', '').replace(',', '').replace('.', '') || ''
  const bModified = b.toString().replace('$', '').replace(',', '').replace('.', '') || ''
  return parseInt(aModified) - parseInt(bModified)
}

export const compareNumbers = (a: number, b:number, keepTheSameRow?: boolean) => {
  if(keepTheSameRow) return 0
  return a - b
}

export const compareDates = (a: string, b: string, format: string, keepTheSameRow?: boolean) => {
  if(keepTheSameRow) return 0
  if(!dayjs(a) || !dayjs(b)) return 0
  return dayjs(dayjs(a).subtract(dayjs(b).unix(), 'millisecond'))
}